<template>
  <div class="character-counter" :class="counterClass">
    <span class="counter-text">
      {{ current }}/{{ max }}
    </span>
    <span v-if="showWarning && remaining <= warningThreshold" class="warning-text">
      还剩 {{ remaining }} 个字符
    </span>
  </div>
</template>

<script>
export default {
  name: 'CharacterCounter',
  props: {
    current: {
      type: Number,
      required: true,
      default: 0
    },
    max: {
      type: Number,
      required: true
    },
    showWarning: {
      type: Boolean,
      default: true
    },
    warningThreshold: {
      type: Number,
      default: 10
    }
  },
  computed: {
    remaining() {
      return Math.max(0, this.max - this.current)
    },
    isOverLimit() {
      return this.current > this.max
    },
    isNearLimit() {
      return this.remaining <= this.warningThreshold && this.remaining > 0
    },
    counterClass() {
      return {
        'over-limit': this.isOverLimit,
        'near-limit': this.isNearLimit && this.showWarning
      }
    }
  }
}
</script>

<style scoped>
.character-counter {
  font-size: 12px;
  color: #909399;
  text-align: right;
  margin-top: 4px;
}

.counter-text {
  font-weight: 500;
}

.warning-text {
  margin-left: 8px;
  color: #E6A23C;
}

.character-counter.near-limit .counter-text {
  color: #E6A23C;
}

.character-counter.over-limit .counter-text {
  color: #F56C6C;
}

.character-counter.over-limit .warning-text {
  color: #F56C6C;
}
</style>